// XNGAGE CONFIDENTIAL
// __________________________
//
// Copyright (C) 2023 Xngage - All Rights Reserved
//
// All code or information contained herein is, and remains the
// property of Xngage LLC and its customers.  The intellectual
// and technical concepts contained are proprietary to Xngage LLC
// and may be covered by U.S. and Foreign Patents, patents in
// process, and are protected by trade secret or copyright law.
// Dissemination of this information or reproduction of this material
// is strictly forbidden unless prior written permission is obtained
// from Xngage LLC.
//

import * as React from "react";

const Account: React.FC = () => {
    return <svg version="1.1" xmlns="http://www.w3.org/2000/svg" xmlnsXlink="http://www.w3.org/1999/xlink" x="0px" y="0px"
	 viewBox="0 0 19 20" enableBackground="new 0 0 19 20" xmlSpace="preserve" fill="currentColor">
<path d="M11.95,10.38c1.65-0.89,2.79-2.61,2.79-4.62c0-2.9-2.36-5.26-5.26-5.26c-2.9,0-5.26,2.36-5.26,5.26c0,2,1.14,3.73,2.79,4.62
	C3.25,11.46,0.5,14.91,0.5,19c0,0.28,0.22,0.5,0.5,0.5s0.5-0.22,0.5-0.5c0-4.39,3.57-7.97,7.97-7.97c0,0,0,0,0.01,0c0,0,0,0,0.01,0
	c4.39,0,7.97,3.58,7.97,7.97c0,0.28,0.22,0.5,0.5,0.5s0.5-0.22,0.5-0.5C18.44,14.91,15.69,11.46,11.95,10.38z M5.21,5.76
	c0-2.35,1.91-4.26,4.26-4.26c2.35,0,4.26,1.91,4.26,4.26c0,2.35-1.91,4.26-4.26,4.26c0,0,0,0,0,0c0,0,0,0,0,0
	C7.12,10.03,5.21,8.11,5.21,5.76z"/>
</svg>;
};

export default React.memo(Account);
